<script>
import { createPulseMarkerOverlayClass } from './pulseMarkerOverlay'

export default {
  name: 'PulseMarker',
  inject: {
    $mapPromise: { default: null },
    $clusterPromise: { default: null },
  },
  props: {
    position: {
      type: Object,
      required: true,
    },
  },
  render() {
    return null
  },
  mounted() {
    this.$mapPromise.then(map => {
      const PulseMarkerOverlay = createPulseMarkerOverlayClass()
      this.overlay = new PulseMarkerOverlay(this.position)
      if (this.$clusterPromise) {
        this.$clusterPromise.then(cluster => {
          this.cluster = cluster
          cluster.addMarker(this.overlay)
        })
      } else {
        this.overlay.setMap(map)
      }
    })
  },
  beforeDestroy() {
    if (!this.overlay) return
    if (this.cluster) {
      this.cluster.removeMarker(this.overlay, true)
    }
    this.overlay.destroyOverlay()
  },
}
</script>
